import { TypingMessage } from '../types';
import { createTypingMessage } from './message.factory';

/**
 * List of reserved ids that are used for special messages.
 */
export const IDS = {
  STICKY_LOADING_MESSAGE: 'sticky-loading-message',
  LOGGED_IN_BY: 'logged-in-by-message',
  USER_EMAIL: 'user-email-message',
  USER_DISPLAY_NAME: 'user-name-message',
  USER_PHONE: 'user-phone-message',
  USER_DESCRIPTION: 'user-description-message',
  USER_OPEN_TICKET: 'user-open-ticket',
  USER_LIVE_CHAT: 'user-live-chat',
  SYSTEM_REQUEST_SUCCESS: 'system-request-success',
  SYSTEM_REQUEST_RESPONSE: 'system-request-response',
  USER_ISSUE_LIST: 'system-user-issues',
  ISSUE_SYSTEM_DESCRIBE_ISSUE: 'issue-system-describe-issue',
  HOW_TO_GET_IN_TOUCH: 'how-to-get-in-touch',
  TRANSACTION_MESSAGE_ID: 'transaction-message',
} as const;

export const DEFAULT_RESOLUTION_MESSAGE = 'Did we resolve the issue?';

export const STICKY_LOADING_MESSAGE: Readonly<TypingMessage> = createTypingMessage(IDS.STICKY_LOADING_MESSAGE);
